import { useMemo } from 'react';
import { Box, Stack } from '@mui/material';

import { useLocalization } from 'localization';
import { ORDER_CREATION_PACKAGE_TYPE } from 'constants/ui/status';
import DataGridTable from 'components/v2/table/DataGridTable';
import { createNewOrderStore } from 'stores/createNewOrderStore';
import { useCreateNewOrderStep2 } from 'hooks/services/useCreateNewOrderStep2';
import { getSaleProductsApi } from 'api/products/query';
import { IProductDto } from 'api/products/dto';

export const CUSTOMIZE_PACKAGE_ID = 'customized';

const CreateOrderStep2 = () => {
  const { t } = useLocalization();
  const { nextStep, formData, setFormData } = createNewOrderStore();
  const isPackageTypeProperty = formData?.packageType === ORDER_CREATION_PACKAGE_TYPE.property;

  const { data, isLoading, isFetching, isRefetching } = getSaleProductsApi({
    branchId: formData?.branchId,
    type: formData?.packageType,
    squareMeter: formData?.property?.livingArea,
    pageNumber: 1, //pageNumber = 1 ~ page 2 on Frontend
    propertyType: formData?.property?.type,
    includeAccountNumberFilter: true,
  });

  const sortedSaleProductByName = useMemo(() => {
    if (!data) return [];
    return [...data].sort((a, b) => a.name.localeCompare(b.name));
  }, [data]);

  const handleChosePackageProduct = (packageProduct?: IProductDto) => {
    setFormData({
      ...formData,
      basicPackage: packageProduct,
    });
    nextStep();
  };

  const { ui } = useCreateNewOrderStep2({ handleChosePackageProduct });
  const tableData =
    isPackageTypeProperty && sortedSaleProductByName
      ? [
          {
            id: CUSTOMIZE_PACKAGE_ID,
            name: t('orders.pages.new.stepOne.buildYourOwnPackageTitle'),
            price: 0,
            children: [],
          },
          ...sortedSaleProductByName,
        ]
      : sortedSaleProductByName;

  return (
    <Stack gap={2} sx={{ margin: '2rem 1rem 1rem 0' }}>
      <Box sx={{ minHeight: 400 }}>
        <DataGridTable
          rows={tableData ?? []}
          columns={ui.table.columns ?? []}
          isHideFooter
          loading={isLoading || isFetching || isRefetching}
          sx={{ minHeight: 200 }}
        />
      </Box>
    </Stack>
  );
};

export default CreateOrderStep2;
